import { Container } from '@cluey/cluey-components';
import moment from 'moment';
import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { api } from '../../../../../api';
import { useMultiStep } from '../../../../common/multi-step';
import { submitChangePause, submitNewPause } from '../../../../legacy/actions';
import { Loader } from '../../../../legacy/components';
import { SelectedEnrolment } from '../../../../legacy/types';
import { PauseEnrolmentContext } from '../../PauseEnrolmentContext';
import PauseEnrolmentForm from '../PauseEnrolmentForm/PauseEnrolmentForm';
import { enrolmentIsPaused, enrolmentWillBePaused } from '../PauseEnrolmentForm/helpers';
import PauseInfoBox from './PauseInfoBox';

export type SelectPauseDateProps = {
  selectedEnrolment: SelectedEnrolment;
};

const SelectPauseDates = () => {
  const context = useContext(PauseEnrolmentContext);
  const { selectedEnrolment } = context;
  const { goToStep } = useMultiStep();
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const dispatch = useDispatch();

  const willBePaused = enrolmentWillBePaused(selectedEnrolment);
  const isPaused = enrolmentIsPaused(selectedEnrolment);

  if (submitting) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  const handleOnSubmitSuccess = () => {
    api.salesforceCase.all.invalidateQueries();
    setSubmitting(false);
    goToStep('pause-success');
  };
  const handleOnSubmitFailed = (error: Error) => {
    setSubmitError(error.message);
    setSubmitting(false);
  };

  return (
    <Container>
      <PauseInfoBox />
      <PauseEnrolmentForm
        submitError={submitError}
        submit={({ pauseStartDate, resumptionDate }) => {
          setSubmitError(null);
          setSubmitting(true);
          const pauseEndDate = moment(resumptionDate).subtract(1, 'day');
          if (isPaused || willBePaused) {
            const payload = {
              enrolmentId: selectedEnrolment.enrolmentSfid,
              currentPauseStart: moment(selectedEnrolment.enrolmentPausedFrom).format('YYYY-MM-DD'),
              selectedResumeDate: pauseEndDate.format('YYYY-MM-DD'),
              doNotOffsetEndDate: true,
              callback: handleOnSubmitSuccess,
              errorCallback: handleOnSubmitFailed,
            };
            dispatch(submitChangePause(payload));
          } else {
            const payload = {
              enrolmentId: selectedEnrolment.enrolmentSfid,
              startDate: moment(pauseStartDate).format('YYYY-MM-DD'),
              endDate: pauseEndDate.format('YYYY-MM-DD'),
              onSubmitSuccess: handleOnSubmitSuccess,
              onSubmitFailed: handleOnSubmitFailed,
            };
            dispatch(submitNewPause(payload));
          }
        }}
      />
    </Container>
  );
};

export default SelectPauseDates;
